export default __webpack_public_path__ + "static/media/account_max_purchase.0c903148.png";